export default __webpack_public_path__ + "static/faith-3d5629478f520e7d13f436c68c028880.png";